<template>
    <div>
        <div class="container-form">
            <div class="row">
                <div v-if="false" class="col-xs-12 col-lg-4">
                    <FormSelect v-model="documents" label="Emissor" icon="fa-building" :options="optionsMyDocuments" :multiple="true" :required="false" tooltip="Selecione o emissor das entregas da carga" ref="documents" />
                </div>
                <div class="col-xs-12 col-lg-4">
                    <FormSelect v-model="drivers" label="Motoristas" icon="fa-user" :options="optionsMyDrivers" :multiple="true" :required="false" tooltip="Selecione o motorista" ref="drivers" />
                </div>
                <div class="col-xs-12 col-lg-4">
                    <FormSelect v-model="license_plates" label="Veículos" icon="fa-truck" :options="optionsMyVehicles" :multiple="true" :required="false" tooltip="Selecione o veículo" ref="license_plates" />
                </div>
                <div class="col-xs-12 col-lg-4">
                    <FormSelect v-model="type" label="Tipo" icon="fa-box" :options="optionsMyTypes" :multiple="true" :required="false" tooltip="Selecione o tipo das entregas" ref="type" />
                </div>
                <div class="col-xs-12 col-lg-4">
                    <FormSelect v-model="cargo" label="Carga" icon="fa-boxes" :options="optionsMyCargos" :multiple="false" :required="false" tooltip="Selecione a carga" ref="cargo" />
                </div>
                <div v-if="false" class="col-xs-12 col-lg-4">
                    <FormInput v-model="date" label="Data de entrega" icon="fa-calendar-alt" type="date" :required="false" tooltip="Informe a data de entrega da carga" ref="date" />
                </div>
                <div v-if="false" class="col-xs-12 col-lg-4">
                    <FormCheckbox v-model="show_period" label="Adicionar período" tooltip="Selecione se deseja definir um período" ref="show_period" />
                </div>
                <div class="col-xs-12 col-lg-4">
                    <FormInput v-model="start_date" label="Início da entrega" icon="fa-calendar-alt" type="date" :min="setDateLimit()" :required="true" tooltip="Informe a data de início da rota de entrega da carga" ref="start_date" />
                </div>
                <div v-if="false" class="col-xs-12 col-lg-3">
                    <FormInput v-model="start_time" label="Hora de início" icon="fa-clock" type="time" :required="false" tooltip="Informe a hora de início da rota de entrega da carga" ref="start_time" />
                </div>
                <div class="col-xs-12 col-lg-4">
                    <FormInput v-model="end_date" label="Término da entrega" icon="fa-calendar-alt" type="date" :min="setDateLimit()" :required="true" tooltip="Informe a data de término da rota de entrega da carga" ref="end_date" />
                </div>
                <div v-if="false" class="col-xs-12 col-lg-3">
                    <FormInput v-model="end_time" label="Hora de término" icon="fa-clock" type="time" :required="false" tooltip="Informe a hora de término da rota de entrega da carga" ref="end_time" />
                </div>
                <div class="col-xs-12 col-lg-3">
                    <FormCheckbox v-model="show_cargo" label="Exibir carga completa" icon="fa-box" tooltip="Selecione se deseja exibir a carga completa, mesmo com entregas contidas na carga não tenham informações contidas no período especificado" ref="show_cargo" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormCheckbox from "@/components/FormCheckbox.vue";
import FormInput from "@/components/FormInput";
import FormSelect from "@/components/FormSelect";

export default {
    name: "ReportForm",

    props: {
        fields: {
            type: Object,
            require: true,
        },
        /*my_documents: {
            type: Array,
            require: true,
        },*/
        my_cargos: {
            type: Array,
            require: true,
        },
        my_drivers: {
            type: Array,
            require: true,
        },
        my_vehicles: {
            type: Array,
            require: true,
        },
    },

    components: {
        FormCheckbox,
        FormInput,
        FormSelect,
    },

    data: function() {
        return {
            //documents: this.fields.documents,
            drivers: this.fields.drivers,
            license_plates: this.fields.license_plates,
            type: this.fields.type,
            cargo: this.fields.cargo,
            //date: this.fields.date,
            //show_period: this.fields.show_period,
            start_date: this.fields.start_date,
            end_date: this.fields.end_date,
            //start_time: this.fields.start_time,
            //end_time: this.fields.end_time,
            show_cargo: this.fields.show_cargo,
        }
    },

    computed: {
        /*optionsMyDocuments: function() {
            let documents = {};
            this.my_documents.map(company => {
				documents[company.document] = company.name.toUpperCase();
			});
            return documents;
        },*/
        
        optionsMyTypes: function() {
            let types = {
                "0": "NOTA FISCAL",
                "1": "PEDIDO",
            };
            return types;
        },

        optionsMyCargos: function() {
            let cargos = {};
            this.my_cargos.map(delivery => {
				cargos[delivery.cargo] = delivery.cargo;
			});
            return cargos;
        },

        optionsMyDrivers: function() {
            let drivers = {};
            this.my_drivers.map(driver => {
				drivers[driver.document] = driver.name.toUpperCase() + " - " + driver.document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
			});
            return drivers;
        },

        optionsMyVehicles: function() {
            let vehicles = {};
            this.my_vehicles.map(vehicle => {
				vehicles[vehicle.license_plate] = vehicle.license_plate + " [" + vehicle.brand + " - " + vehicle.bodywork + "]";
			});
            return vehicles;
        },
    },

    methods: {
        // Verifica e valida inicialmente os campos
        validate: function() {
            let result = {
                //documents: [],
                drivers: [],
                license_plates: [],
                type: [],
                cargo: "",
                //date: "",
                start_date: "",
                end_date: "",
                //start_time: "",
                //end_time: "",
                show_cargo: false,
            };
            let error = false;

            // Empresas
			/*if (this.documents != []) {
                result.documents = this.documents;
			}*/

            // Motorista
			if (this.drivers != []) {
                result.drivers = this.drivers;
			}
            
            // Placa
			if (this.license_plates != []) {
				result.license_plates = this.license_plates;
			}

            // Tipos
			if (this.type != []) {
                result.type = this.type;
			}
            
            // Cargo
			if (this.cargo != "") {
				result.cargo = this.cargo;
			}

            // Data
			/*if (this.date != "") {
                let new_date = this.date.split("/");
                new_date = new Date(new_date[2], new_date[1] - 1, new_date[0], 23, 59, 59);
                
                //if(new_date > new Date()) {
                //    this.$refs.date.error = "Não pode ser maior";
                //    this.$notification.error("'DATA DE ENTREGA' não pode ser maior que a data atual.");
                //    error = true;
                //} else {
                    result.date = new_date.getFullYear() + "-" + (new_date.getMonth() + 1) + "-" + new_date.getDate();
                //}
            }*/
            
            // Verifica se busca por período
            //if (this.show_period) {
                let start_date = "";
                let end_date = "";
                let today = new Date();
                let limit = new Date(today.getFullYear(), today.getMonth() - 2, today.getDate(), 0, 0, 0);
                
                // Data de início
                if (this.start_date != "") {
                    start_date = this.start_date.split("-");
                    start_date = new Date(start_date[0], start_date[1] - 1, start_date[2], 0, 0, 0);
                    if ((this.cargo == "") && (start_date < limit)) {
                        this.$refs.start_date.error = "Deve estar dentro do período limite de dois meses";
                        this.$notification.error("'INÍCIO DA ENTREGA' deve estar dentro do período de dois meses anterior a data atual.");
                        error = true;
                    } else if (start_date > today) {
                        this.$refs.start_date.error = "Não pode ser maior";
                        this.$notification.error("'INÍCIO DA ENTREGA' não pode ser maior que a data atual.");
                        error = true;
                    } else {
                        let month = start_date.getMonth() + 1;
                        result.start_date = start_date.getFullYear() + "-" + (month < 10 ? "0" + month : month) + "-" + start_date.getDate();
                    }
                } else {
                    if (this.cargo == "") {
                        this.$refs.start_date.error = "Deve ser informada";
                        this.$notification.error("'INÍCIO DA ENTREGA' deve ser informado em caso de 'CARGA' não informada.");
                        error = true;
                    }
                }
                
                // Data de término
                if (this.end_date != "") {
                    end_date = this.end_date.split("-");
                    end_date = new Date(end_date[0], end_date[1] - 1, end_date[2], 23, 59, 59);
                    if ((this.cargo == "") && (end_date < limit)) {
                        this.$refs.end_date.error = "Deve estar dentro do período limite de dois meses";
                        this.$notification.error("'TÉRMINO DA ENTREGA' deve estar dentro do período de dois meses anterior a data atual.");
                        error = true;
                    } else /*if (end_date > today) {
                        this.$refs.end_date.error = "Não pode ser maior";
                        this.$notification.error("'TÉRMINO DA ENTREGA' não pode ser maior que a data atual.");
                        error = true;
                    } else*/ {
                        let month = end_date.getMonth() + 1;
                        result.end_date = end_date.getFullYear() + "-" + (month < 10 ? "0" + month : month) + "-" + end_date.getDate();
                    }
                } else {
                    if (this.cargo == "") {
                        this.$refs.end_date.error = "Deve ser informada";
                        this.$notification.error("'TÉRMINO DA ENTREGA' deve ser informado em caso de 'CARGA' não informada.");
                        error = true;
                    }
                }
                
                // Verifica a relação esntre as datas do período
                if ((this.start_date != "") && (this.end_date != "")) {
                    if (start_date > end_date) {
                        this.$refs.start_date.error = "Não pode ser maior que o término";
                        this.$refs.end_date.error = "Não pode ser menor que o início";
                        this.$notification.error("'INÍCIO DA ENTREGA' não pode ser maior que o 'TÉRMINO DA ENTREGA'.");
                        error = true;
                    }
                }
                
                // Hora de início
                /*if (this.start_time != "") {
                    if (this.start_date != "") {
                        result.start_time = this.start_time;
                    } else {
                        this.$refs.start_date.error = "Deve ser preenchido";
                        this.$notification.error("'INÍCIO DA ENTREGA' deve ser preenchido.");
                        error = true;
                    }
                }
                
                // Hora de término
                if (this.end_time != "") {
                    if (this.end_date != "") {
                        result.end_time = this.end_time;
                    } else {
                        this.$refs.end_date.error = "Deve ser preenchido";
                        this.$notification.error("'TÉRMINO DA ENTREGA' deve ser preenchido.");
                        error = true;
                    }
                }*/
            //}

            // Show Cargo
			if (this.show_cargo) result.show_cargo = true;
            else result.show_cargo = false;

            // Verifica se foi encontrado algum erro
            if(error) {
                return null;
            } else {
                this.$emit("update", {
                    //documents: this.documents,
                    drivers: this.drivers,
                    license_plates: this.license_plates,
                    type: this.type,
                    cargo: this.cargo,
                    //date: this.date,
                    //show_period: this.show_period,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    //start_time: this.start_time,
                    //end_time: this.end_time,
                    show_cargo: this.show_cargo,
                });

                return result;
            }
        },

        // Retorna messagem de erro no campo determinado
        message: function(input) {
            return "'" + input + "' deve ser preenchido.";
        },

        setDateLimit: function() {
            let today = new Date();
            let limit = new Date(today.getFullYear(), today.getMonth() - 2, today.getDate(), 0, 0, 0);
            let month = limit.getMonth() + 1;
            return limit.getFullYear() + "-" + (month < 10 ? "0" + month : month) + "-" + limit.getDate();
        },
    }
}
</script>

<style scoped>
.container-form {
    padding: 15px;
    border: 1px solid #f0f0f0;
    background-color: #fff;
}

.container-button {
    padding: 15px;
    border: 1px solid #f0f0f0;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    background-color: #fff;
}

.button-edit {
    padding: 10px 20px;
	font-size: 14px;
	font-weight: bold;
}
</style>